__webpack_require__.p = "https://assets-01.periodica.press/487511a-20141334073/";